import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user_service';

export const loginRedirectGuard: CanActivateFn = () => {
    const userService = inject(UserService);
    const platformId = inject(PLATFORM_ID);
    
    if (isPlatformServer(platformId)) {
        return true; 
    }
    
    return userService.getProfile().then(user => {
        if (user && user.id !== '') {
            return true;
        } else {
            return userService.login().then(() => {
                return false;
            }).catch(() => {
                return false; 
            });
        }
    }).catch(() => {
        return userService.login().then(() => false).catch(() => false); 
    });
};